/**
 * Document Management — single-tab unified view.
 * (Yeni Belge, Grup Şirketleri ve Ülkelere Göre sekmeleri kaldırıldı.)
 */
import React from 'react';
import UnifiedDocumentsList from './UnifiedDocumentsList';

const DocumentManagement = () => {
  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-800">Belge Yönetimi</h1>
        <p className="text-gray-600 mt-1">
          Tüm belgelerinizi (manuel + avans kapama makbuzları) tek bir yerden görüntüleyin.
        </p>
      </div>

      {/* Content */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <UnifiedDocumentsList />
      </div>
    </div>
  );
};

export default DocumentManagement;
